/* eslint-disable space-before-function-paren */
import application from 'application/application';
import UserClientFunctionalities from '../../classes/user-client/UserClientFunctionalities';

application.service('permissions', [
	'$http',
	'helper',
	'API',
	function($http, helper, API) {
		let update,
			userFeatures = [],
			userFeaturesPromise = null,
			clientUserFunctionalities = [],
			clientUserFunctionalitiesPromise = null,
			map = {
				publications: {
					createDiary: -1, // Cadastrar diários
					createKeyword: -2, // Cadastrar palavras-chave
					createSearchVariation: -3, // Cadastrar variações de pesquisa
					createExclusionVariation: -4, // Cadastrar variações de exclusão
					combinedSearch: -5, // Cadastrar busca combinada
					downloadPublications: -6, // Gerar publicações em arquivo
					recordPublications: -7 // Consultar publicações
				},
				processes: {
					createProcess: -8, // Cadastrar processos
					createMovements: -9, // Consultar andamentos
					createManualMovements: -10, // Cadastrar andamentos manuais
					transformProcessIntoManual: -11, // Transformar processo automático em manual
					downloadMovements: -12, // Gerar andamentos em arquivo
					transformProcessIntoAutomatic: -16, // Transformar processo manual em automático
					processesWithAutomaticMovementsSearch: -32, // Processos com busca automática de andamentos
					searchAutomaticMovements: -31 // Pesquisar andamentos automáticos
				},
				insurance: {
					createInsurance: -18 // Contratar seguro
				},
				schedule: {
					createSchedule: -21, // Criar agenda
					recordSchedule: -22, // Consultar agenda
					createAppointments: -23 // Cadastrar compromissos em agenda
				},
				finances: {
					financesLowsMaintenance: -50, // Manutenção de Baixas Financeiras
					financesLowsConsultation: -49, // Consultar Baixas Financeiras
					financesAccountJumps: -48, // Consultar Saldos de Contas Financeiras
					financesPostingsMaintenance: -47, // Manutenção de Lançamentos Financeiros
					financesPostingsConsultation: -46, // Consultar Lançamentos Financeiros
					financesAccountsMaintenance: -45, // Manutenção de Contas Financeiras
					financesAccountsConsultation: -44, // Consultar Contas Financeiras
					financesCategoriesMaintenance: -43, // Manutenção de Categorias
					financesCategoriesConsultation: -42, // Consultar Categorias
					financesMaintenance: -41, // Manutenção de Financeiros
					financesConsultation: -40 // Consultar Financeiros
				},
				contacts: {
					createContactList: -24, // Criar lista de contato
					createContactType: -25, // Criar tipos de contato
					createContact: -26, // Criar contatos
					recordContacts: -27, // Consultar contatos
					createContactActivity: -28, // Cadastrar atividades de contato
					recordContactActivity: -29 // Ver atividades de contatos
				},
				custummers: {
					createUsers: -30 // Cadastrar usuários
				},
				people: {
					contactListMaintenance: -29, // Manutenção de Lista de Contatos
					consultContactList: -28, // Consultar Lista de Contatos
					maintainingMarkers: -27, // Manutenção de Marcadores
					consultBookmarks: -26, // Consultar Marcadores
					contactMaintenance: -25, // Manutenção de Contatos
					consultContacts: -24 // Consultar Contatos
				},
				subpoena: {
					createSubpoena: -72
				}
			};

		function getCachedClientUserFunctionalities() {
			const cache = localStorage.getItem('__clientUserFunctionalities__');

			if (cache) {
				const parsed = JSON.parse(cache);
				const now = Date.now();

				if (now - parsed.timestamp < 10 * 60 * 1000) {
					return parsed.data;
				}
			}

			return null;
		}

		function setCachedClientUserFunctionalities(data) {
			localStorage.setItem(
				'__clientUserFunctionalities__',
				JSON.stringify({ timestamp: Date.now(), data })
			);
		}

		function loadClientUserFunctionalities(
			$http,
			helper,
			API,
			permission = null
		) {
			if (clientUserFunctionalitiesPromise) {
				return clientUserFunctionalitiesPromise;
			}

			const userClientFunctionalities = new UserClientFunctionalities(
				permission,
				$http,
				helper,
				API
			);

			clientUserFunctionalitiesPromise = userClientFunctionalities
				.getItems()
				.then(response => {
					clientUserFunctionalities = response.data.itens;
					setCachedClientUserFunctionalities(clientUserFunctionalities);

					return clientUserFunctionalities;
				})
				.finally(() => {
					clientUserFunctionalitiesPromise = null;
				});

			return clientUserFunctionalitiesPromise;
		}

		function getCachedUserFeatures() {
			const cache = localStorage.getItem('__userFeatures__');

			if (cache) {
				const parsed = JSON.parse(cache);
				const now = Date.now();

				if (now - parsed.timestamp < 10 * 60 * 1000) {
					return parsed.data;
				}
			}

			return null;
		}

		function setCachedUserFeatures(data) {
			localStorage.setItem(
				'__userFeatures__',
				JSON.stringify({ timestamp: Date.now(), data })
			);
		}

		function loadUserFeatures($http, helper, API) {
			if (userFeaturesPromise) {
				return userFeaturesPromise;
			}

			userFeaturesPromise = $http({
				...helper.http(API.permissions, 'GET'),
				params: {
					...helper.httpFields([
						'idFuncionalidade',
						'idUsuarioClienteXFuncionalidade',
						'quantidadePermitida',
						'quantidadeUtilizada'
					]),
					registrosPorPagina: -1,
					ativo: true
				}
			})
				.then(response => {
					userFeatures = response.data.itens;
					setCachedUserFeatures(userFeatures);

					return userFeatures;
				})
				.finally(() => {
					userFeaturesPromise = null;
				});

			return userFeaturesPromise;
		}

		class Permission {
			constructor(permission) {
				const cached = getCachedClientUserFunctionalities();

				if (cached) {
					clientUserFunctionalities = cached;
				} else {
					loadClientUserFunctionalities($http, helper, API, permission).then(
						data => {
							clientUserFunctionalities = data;
						}
					);
				}

				if (map.hasOwnProperty(permission)) this.permission = permission;
				else
					throw new Error(`"${permission}" is not a valid permission alias.`);
			}

			has(name) {
				let features = map[this.permission];

				if (typeof features === 'object' && features.hasOwnProperty(name)) {
					return !!(
						userFeatures &&
						userFeatures.find(
							dbFeature => dbFeature.idFuncionalidade === features[name]
						)
					);
				} else return false;
			}

			getAmount(name, data = null) {
				let features = map[this.permission];

				localStorage.setItem(
					'__checkCreditPlan__',
					JSON.stringify(clientUserFunctionalities)
				);

				if (
					typeof features === 'object' &&
					features.hasOwnProperty(name) &&
					this.has(name)
				) {
					const { totalContratadoUsuarioCliente, qtdDisponivel, qtdUtilizada } =
						clientUserFunctionalities && clientUserFunctionalities.length > 0
							? clientUserFunctionalities[0]
							: {
									totalContratadoUsuarioCliente: 0,
									qtdDisponivel: 0,
									qtdUtilizada: 0
							  };

					if (data == 'QUANTIDADE_PERMITIDA') {
						return totalContratadoUsuarioCliente;
					} else if (data == 'QUANTIDADE_UTILIZADA') {
						return qtdUtilizada;
					}

					return qtdDisponivel;
				} else return 0;
			}

			getProp(name, prop) {
				let features = map[this.permission];

				if (
					typeof features === 'object' &&
					features.hasOwnProperty(name) &&
					this.has(name)
				) {
					let feature = userFeatures.find(
						dbFeature => dbFeature.idFuncionalidade === features[name]
					);

					return feature[prop];
				} else return undefined;
			}

			update() {
				return update();
			}
		}

		this.get = name => new Permission(name);

		this.update = () => {
			const cached = getCachedUserFeatures();

			if (cached) {
				userFeatures = cached;

				return Promise.resolve(cached);
			} else {
				return loadUserFeatures($http, helper, API).then(data => {
					userFeatures = data;
				});
			}
		};

		update = this.update;

		this.update();
	}
]);
